import React from "react";
import "./FileStats.css";
import { Button } from "primereact/button";
const FileStats = ({
  data,
  header,
  setShowStats,
  setFileUploadDetails,
  duplicateRows,
  color,
}) => {
  return (
    <div className="filestats">
      <div className="filestatsinner">
        <button className="backicon">
          <i
            className="pi pi-angle-left"
            style={{ fontSize: "1.5rem", color: "#323232" }}
          ></i>
        </button>
        <h1>
          {header}:{" "}
          <span style={{ color: color === "success" ? "#27AE60" : "#B3261E" }}>
            {" "}
            {data?.length > 0 ? data?.length : duplicateRows?.length}
          </span>
        </h1>
        <div className="datamain">
          <div className="data">
            {data?.length > 0
              ? data?.map((items, id) => <p key={id}>{items}</p>)
              : duplicateRows.map((items, id) => <p key={id}>{items?.ESN}</p>)}
          </div>
        </div>
        <div className="filestatsbtn">
          <Button
            label="Cancel"
            className="backbtn"
            onClick={() => {
              setShowStats(false);
              setFileUploadDetails(true);
            }}
          />
          <Button label="Submit" className="nextbtn" />
        </div>
      </div>
    </div>
  );
};

export default FileStats;
